import templateUrl from './component.tpl.html';
import AlNavigationMainComponentController from './controller';

angular.module('festzelt-os.modules.navigation')
    .component('alNavigationMain', {
        controller: AlNavigationMainComponentController,
        controllerAs: 'vm',
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/navigation/components/al-navigation-main/component.js